import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDSUser } from '../../models/user';
import type { AppDispatch } from '../index';
import type { RootState } from '.';

export type UsersState = {
  loading: boolean;
  hasErrors: boolean;
  user: IDSUser;
  ouId: string;
};
//

export const initialState: UsersState = {
  loading: false,
  hasErrors: false,
  user: null,
  ouId: null,
};

// A slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    saveUser: (state, action: PayloadAction<IDSUser>) => {
      state.user = action.payload;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    getUserSuccess: (state, action: PayloadAction<IDSUser>) => {
      state.user = action.payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getUserFailure: (state) => {
      state.loading = false;
      // handling Errors
      state.hasErrors = true;
    },
    saveOuId: (state, action) => {
      state.ouId = action.payload;
    },
  },
});

const { saveUser, startLoading, getUserFailure, getUserSuccess, saveOuId } = userSlice.actions;

// export user selector to get the slice in any component
export const userSelector = (state: RootState) => state.user;
// export The reducer
const userReducer = userSlice.reducer;
export default userReducer;

// Actions

export const Save =
  (User: IDSUser): any =>
  async (dispatch: AppDispatch) => {
    try {
      // const ouId = localStorage.getItem('ouId');
      // console.log('ouId', ouId);
      // if (!ouId) {
      //     localStorage.setItem('ouId',User.profile.ou_id);
      //     dispatch(saveOuId(User.profile.ou_id))
      // }
      // dispatch(saveOuId(User.profile.ou_id))
      // dispatch(saveOuId(ouId))
      dispatch(saveUser(User));
    } catch (error) {
      dispatch(getUserFailure());
    }
  };
